import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { Converter } from '../shared';
import { KeyAndPassword, Email, Password } from '../models';
import { Account } from '../models/account.model';
import { Faculty } from '../models/faculty.model';

@Injectable()
export class AccountService {

    constructor(private http: Http) {
    }

    public register(account: Account): Observable<any> {
        const copy = Converter.toJson(account);
        return this.http.post('api/register', copy);
    }

    public activate(key: string): Observable<any> {
        return this.http.get(`api/activate?key=${key}`);
    }

    public initializePasswordReset(email: Email): Observable<any> {
        const copy = Converter.toJson(email);
        return this.http.post('api/account/reset-password/init', copy);
    }

    public finishPasswordReset(keyAndPassword: KeyAndPassword): Observable<any> {
        const copy = Converter.toJson(keyAndPassword);
        return this.http.post('api/account/reset-password/finish', copy);
    }

    public changePassword(newPassword: Password): Observable<any> {
        const copy = Converter.toJson(newPassword);
        return this.http.post('api/account/change-password', copy);
    }

    public get(): Observable<Account> {
        return this.http.get('api/account').map((response: Response) => {
            return Converter.fromJson(Account, response.json());
        });
    }

    public update(account: Account): Observable<any> {
        const copy = Converter.toJson(account);
        return this.http.put('api/account', copy);
    }

    public userFaculties(): Observable<Array<Faculty>> {
        return this.http.get('api/account/faculties').map((response: Response) => {
            return Converter.fromJsonArray(Faculty, response.json());
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/services/account.service.ts